import { Forecast } from "../../types";
import { WeatherIcon } from "../weatherIcon";
import { forecastDayConditions, parseNumber, rateConditions } from "../../utils/conditions";
import { dayLabel, dayNote, dayRainText, localTime } from "../../utils/areaForecast";
import { ConditionsMeter } from "./conditionsScore";
import { RatingButton } from "../ratingButton";
import { SectionCard } from "./sectionCard";
import { IconCalendar, IconDrop } from "./icons";
import "./weekCard.css";


interface WeekCardProps {
    forecast: Forecast;
    now: number;
}

export function WeekCard({ forecast, now }: WeekCardProps) {
    const tz = forecast.timezone;
    const days = forecast.daily?.data ?? [];

    return (
        <SectionCard className="area-page__week" icon={<IconCalendar />} title="This week">
            {days.length === 0 ? (
                <p className="cw-card__message">The daily forecast isn’t available right now.</p>
            ) : (
                <ol className="week">
                    {days.map((dp, i) => {
                        const conditions = forecastDayConditions(forecast, i);
                        const rating = rateConditions(conditions);
                        const high = parseNumber(dp.temperatureHigh);
                        const low = parseNumber(dp.temperatureLow);
                        const rain = dayRainText(conditions);

                        return (
                            <li key={dp.time} className="week__day">
                                <div className="week__when">
                                    <span className="week__dow">{dayLabel(dp.time, tz, now, true)}</span>
                                    <span className="week__date">{localTime(dp.time, tz).monthDay}</span>
                                </div>
                                <WeatherIcon code={dp.icon} size={32} />
                                <div className="week__verdict">
                                    <RatingButton
                                        conditions={conditions}
                                        period="day"
                                        context={`${dayLabel(dp.time, tz, now)}, ${localTime(dp.time, tz).monthDay}`}
                                    >
                                        <ConditionsMeter rating={rating} />
                                    </RatingButton>
                                    <span className="week__note">{dayNote(rating)}</span>
                                </div>
                                <div className="week__temps">
                                    <span className="week__high">
                                        <span className="cw-sr-only">High </span>{high !== undefined ? `${Math.round(high)}°` : "–"}
                                    </span>
                                    <span className="week__low">
                                        <span className="cw-sr-only">, low </span>{low !== undefined ? `${Math.round(low)}°` : "–"}
                                    </span>
                                </div>
                                {rain && (
                                    <span className="week__precip">
                                        <IconDrop />
                                        <span className="cw-sr-only">Rain: </span>{rain}
                                    </span>
                                )}
                            </li>
                        );
                    })}
                </ol>
            )}
        </SectionCard>
    );
}
